import gql from 'graphql-tag'
import chatFragment from './ChatFragment'

export const CHATS_QUERY = gql `
  query getChatMessage($room: String) {
    chats: getChatMessage(room: $room) {
      ...${chatFragment}
    }
  }
`

export const CHATS_QUERY_OUT = gql`
  query getChatMessageSuport_K($room: String) {
    chats: getChatMessageSuport_K(room: $room) {
      ...${chatFragment}
    }
  }
`



export const CHATS_ROOM_QUERY = gql `
  query getReciveMessageEntity{
    recivedChats: getReciveMessageEntity {
      room :name
      testID: test
      flag
      messages{
        body
        time
        read
        date
        flag_to
        
        author {
          id
          name
          photo
          type
        }

        to{
          id
          name
          photo
          type
        }
      }
    }
  }
`

export const CHECK_CHAT_SUPORT = gql `
  query checkSuportMessage($id: ID) {
    checkSuportMessage(id:$id) {
      flag
    }
  }
`

export const CHATS_QUERY_OUT_LIST = gql`
  query getReciveMessageSuportEntity_K($id: ID) {
    chatsWL: getReciveMessageSuportEntity_K(id: $id){
       room :name
      testID: test
      from
      messages{
        body
        time
        read
        date
        flag_to
        author{
          id
          name
          photo
        }
        to{
          id
          name
          photo
        }
      }
    }
  }
`
export const CHATS_ROOM_QUERY_UPD = gql`

  query getReciveMessageSuport_K {
    getReciveMessageSuport_K {
      room :name
      testID: test
      from
      messages{
        body
        time
        read
        date
        flag_to
        author{
          id
          name
          photo
        }
      }
    }
  }
`